// React Native Android's Fabric renderer throws
// `JSApplicationIllegalArgumentException` on unknown `accessibilityRole`
// values, which tears down the React instance and crashes the app. Web-flavored
// ARIA landmark roles like `contentinfo`, `main`, `banner`, `region`, etc., are
// useful for SEO/a11y on the DOM but unsupported by the native ViewManager.
//
// `safeAccessibilityRole(role)` returns the role unchanged on web (and on the
// safe-list of values RN Android understands), and returns `undefined` for
// roles RN Android would reject — so the same JSX can stay declarative without
// peppering callsites with `Platform.OS === 'web' ?` ternaries.
import { Platform } from 'react-native';

const NATIVE_VALID_ROLES = new Set([
  'none',
  'button',
  'togglebutton',
  'link',
  'search',
  'image',
  'keyboardkey',
  'text',
  'adjustable',
  'imagebutton',
  'header',
  'summary',
  'alert',
  'checkbox',
  'combobox',
  'menu',
  'menubar',
  'menuitem',
  'progressbar',
  'radio',
  'radiogroup',
  'scrollbar',
  'spinbutton',
  'switch',
  'tab',
  'tablist',
  'timer',
  'toolbar',
  'list',
]);

const HEADING_ALIASES = new Set(['heading', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']);

export function safeAccessibilityRole(role) {
  if (typeof role !== 'string' || role.length === 0) return undefined;
  if (Platform.OS === 'web') return role;
  const lower = role.toLowerCase();
  if (HEADING_ALIASES.has(lower)) return 'header';
  if (lower === 'slider') return 'adjustable';
  if (NATIVE_VALID_ROLES.has(lower)) return lower;
  return undefined;
}

export default safeAccessibilityRole;
